._item_1db54_1 {
  cursor: pointer; }

._item_1db54_1 .control-icon-button {
  padding: 0;
  border: none; }

._item_1db54_1 .control-icon-button > .symbol {
  width: 24px;
  height: 24px; }

._item_1db54_1 .control-label {
  cursor: pointer;
  display: inline; }

._item_1db54_1 .title-wrapper .control-label {
  color: #162d3d; }

._item_1db54_1 .description-wrapper .control-label-base {
  color: #2b5672; }
